import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import backArrowIcon from '../../assets/img/back-arrow.png';
import { formatDateToYYYYMMDD } from '../../utils/format-time';
import exportIcon from '../../assets/icon/icon-export-excel.svg';
import { API_URL } from '../../utils/constant';
import { formatReceiptCurrency } from '../../utils/format-number';
import axios from 'axios';
import * as XLSX from 'xlsx';
import Select from 'react-select';
import { Pagination } from '../../components/Pagination';

const LIMIT = 20;

const WholesaleReport = () => {
  const backPath = '/report/list';
  const REPORT_TIMESPAN = 'daily';

  const today = new Date();
  const oneMonthAgo = new Date(today);
  oneMonthAgo.setMonth(today.getMonth() - 1);

  const [startDate, setStartDate] = useState(formatDateToYYYYMMDD(oneMonthAgo));
  const [endDate, setEndDate] = useState(formatDateToYYYYMMDD(today));
  const [data, setData] = useState([]);
  const [salePersons, setSalePersons] = useState();
  const [salePerson, setSalePerson] = useState();
  const [page, setPage] = useState(1);
  const visibleData = data.slice((page - 1) * LIMIT, page * LIMIT);

  const salePersonOptions = (salePersons || []).map((item) => ({
    value: item.user_id,
    label: item.name,
  }));

  const salesPersonSelectStyles = {
    container: (base) => ({
      ...base,
      minWidth: 220,
    }),
    control: (base) => ({
      ...base,
      minHeight: 50,
      height: 50,
      borderColor: 'rgba(0, 0, 0, 0.15)',
      boxShadow: 'none',
    }),
    valueContainer: (base) => ({
      ...base,
      height: 50,
      padding: '0 14px',
    }),
    indicatorsContainer: (base) => ({
      ...base,
      height: 50,
    }),
    menuList: (base) => ({
      ...base,
      maxHeight: 216,
      overflowY: 'auto',
    }),
    menu: (base) => ({
      ...base,
      zIndex: 20,
    }),
  };

  async function fetchWholeReport(fromDate, toDate, selectedSalePerson) {
    const url = `${API_URL}/report/wholesale_report?fromDate=${fromDate}&toDate=${toDate}&cashier_id=${selectedSalePerson}&timespan=${REPORT_TIMESPAN}`;
    return axios
      .get(url, {
        withCredentials: true,
      })
      .then((response) => {
        setData(response.data.data);
      })
      .catch((e) => {
        console.log(e.response);
      });
  }

  useEffect(() => {
    axios
      .get(API_URL + '/user?status=ACTIVE&limit=100000&page=1&sort=name', {
        withCredentials: true,
      })
      .then((response) => {
        setSalePersons(response.data.data);
        setSalePerson(response.data.data[0]?.user_id);
      });
  }, []);

  useEffect(() => {
    setPage(1);
  }, [data]);

  const handleExportClick = (fileName) => {
    const table = document.querySelector('#xlsx-export-all').cloneNode(true);
    const workbook = XLSX.utils.table_to_book(table, { display: false });
    XLSX.writeFile(workbook, fileName);
  };

  return (
    <div className='sub-page-layout-1'>
      <div className='container' style={{ height: 'auto' }}>
        <div className='report-page-header text-3xl'>
          <div className='report-page-heading'>
            <Link className='back-to-page' to={backPath}>
              <img src={backArrowIcon} />
              Back
            </Link>
            <h1 className='sub-page-title'>Wholesale Report</h1>
          </div>

          <div className='report-toolbar'>
            <div className='report-filter-group'>
              <div className='report-select-wide'>
                <div className='dd-container'>
                  <Select
                    classNamePrefix='report-select'
                    options={salePersonOptions}
                    value={salePersonOptions.find((item) => item.value === salePerson) || null}
                    onChange={(selectedOption) => setSalePerson(selectedOption?.value || '')}
                    placeholder='Select'
                    maxMenuHeight={216}
                    styles={salesPersonSelectStyles}
                  />
                </div>
              </div>
              <input
                required
                name='start_date'
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                className='x-input report-date-input'
                type='date'
              />
              <input
                required
                name='end_date'
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
                className='x-input report-date-input'
                type='date'
              />
              <button
                className='gold-btn report-run-button'
                onClick={() => fetchWholeReport(startDate, endDate, salePerson)}
              >
                Run Report
              </button>
              <button
                className='gold-btn report-export-button'
                onClick={() => {
                  handleExportClick(`Wholesale_Report_from_${startDate}_to_${endDate}.xlsx`);
                }}
              >
                <img src={exportIcon} alt='export excel icon' />
                <span>Export Excel</span>
              </button>
            </div>
          </div>
        </div>
        <div className='table-container'>
          <table className='x-table' id='xlsx-export'>
            <thead>
              <tr style={{ position: 'absolute', width: '0', height: '0', padding: '0', border: '0' }}>
                <th className='hidden'>From</th>
                <th className='hidden'>{startDate}</th>
                <th className='hidden'>To</th>
                <th className='hidden'>{endDate}</th>
              </tr>
              <tr style={{ position: 'absolute', width: '0', height: '0', padding: '0', border: '0' }}>
                <th className='hidden' colSpan={2}></th>
              </tr>
              <tr>
                <th>Date</th>
                <th>Voucher No</th>
                <th className='report-amount'>MMK Total</th>
                <th className='report-amount'>THB Total</th>
                <th className='report-amount'>Advanced MMK</th>
                <th className='report-amount'>Advanced THB</th>
                <th className='report-amount'>MMK Discount</th>
                <th className='report-amount'>THB Discount</th>
                <th className='report-amount'>MMK Net Total</th>
                <th className='report-amount'>THB Net Total</th>
              </tr>
            </thead>
            <tbody>
              {visibleData?.map((item, i) => (
                <tr key={i}>
                  <td>{item['sale_date']}</td>
                  <td>{item['voucher_code']}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['sub_total_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['sub_total_thb'], 'THB')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['advanced_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['advanced_thb'], 'THB')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['discount_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['discount_thb'], 'THB')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['total_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['total_thb'], 'THB')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div style={{ display: 'none' }}>
          <table id='xlsx-export-all'>
            <thead>
              <tr>
                <th>Date</th>
                <th>Voucher No</th>
                <th className='report-amount'>MMK Total</th>
                <th className='report-amount'>THB Total</th>
                <th className='report-amount'>Advanced MMK</th>
                <th className='report-amount'>Advanced THB</th>
                <th className='report-amount'>MMK Discount</th>
                <th className='report-amount'>THB Discount</th>
                <th className='report-amount'>MMK Net Total</th>
                <th className='report-amount'>THB Net Total</th>
              </tr>
            </thead>
            <tbody>
              {data?.map((item, i) => (
                <tr key={`export-${i}`}>
                  <td>{item['sale_date']}</td>
                  <td>{item['voucher_code']}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['sub_total_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['sub_total_thb'], 'THB')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['advanced_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['advanced_thb'], 'THB')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['discount_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['discount_thb'], 'THB')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['total_mmk'], 'MMK')}</td>
                  <td className='report-amount'>{formatReceiptCurrency(item['total_thb'], 'THB')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className='w-full flex justify-end mt-4'>
          <Pagination page={page} totalCount={data.length} limit={LIMIT} onChange={setPage} />
        </div>
      </div>
    </div>
  );
};

export default WholesaleReport;
